module.exports = __webpack_public_path__ + "static/media/SNK.35b38aef.mp4";